var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-border-b gl-flex gl-flex-col gl-py-5 @sm/panel:gl-flex-row"},[_c('h1',{staticClass:"gl-heading-2 gl-flex-1 @sm/panel:gl-mb-0",attrs:{"data-testid":"work-item-list-title"}},[_vm._v("\n    "+_vm._s(_vm.s__('WorkItem|Work items'))+"\n  ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }